import React, { useState } from 'react';
import { seedInfo } from '../../data/compPlan';
import { Button } from '../sf/Button';
import { Modal } from '../sf/Modal';
import { NewBadge } from '../sf/NewBadge';
import { Switch } from '../sf/Switch';
interface LoadDefaultsModalProps {
  open: boolean;
  onClose: () => void;
  onLoad: (includeSampleData: boolean) => void;
}
export function LoadDefaultsModal({
  open,
  onClose,
  onLoad
}: LoadDefaultsModalProps) {
  const [includeSampleData, setIncludeSampleData] = useState(false);
  const facts = [{
    label: 'Seed version',
    value: seedInfo.seedVersion
  }, {
    label: 'Where allowed',
    value: 'Any sandbox. In production: admin-only, one-time load.'
  }];
  return <Modal open={open} onClose={onClose} title="Load Default Rules" description="Seeds Base BPS, Monthly Bonus, Divisor, TL Rate and Fee Short rules from the seed version." footer={<>
          <Button onClick={onClose} data-id="element-123" data-mp="3di1gp3cwk2pc">Cancel</Button>
          <Button variant="brand" onClick={() => onLoad(includeSampleData)} data-id="element-124" data-mp="w66ve0o9yz07">
            Load Rules
          </Button>
        </>} data-id="element-122" data-mp="3nffwr1uwyph4">
      <p className="mb-3 flex flex-wrap items-center gap-2 text-xs text-sf-weak" data-id="element-125" data-mp="10xyjm4jyksn6">
        <NewBadge data-id="element-126" data-mp="m8se5yuj266u" />
        The rule seeder is a proposed rebuild feature — main has no rule tables to seed today.
      </p>
      <dl className="divide-y divide-sf-border rounded border border-sf-border" data-id="element-127" data-mp="r7vh9dqy62c6">
        {facts.map(fact => <div key={fact.label} className="grid grid-cols-[130px_minmax(0,1fr)] gap-3 px-3 py-2 text-[13px]" data-id="element-128" data-mp="1exg2y4ehjdp5">
            <dt className="text-sf-weak" data-id="element-129" data-mp="1jtoobzja034r">{fact.label}</dt>
            <dd className={fact.label === 'Seed version' ? 'font-mono text-xs leading-5' : ''} data-id="element-130" data-mp="14xgx4f9ga1fz">{fact.value}</dd>
          </div>)}
      </dl>
      <div className="mt-4 flex items-center justify-between gap-4" data-id="element-131" data-mp="19zeltp0mdogb">
        <div data-id="element-132" data-mp="3pn6aenui9f6k">
          <p className="text-[13px] font-semibold" data-id="element-133" data-mp="3pqu3xmzya1la">Include sample data</p>
          <p className="text-xs text-sf-weak" data-id="element-134" data-mp="3uoltiad4hbmb">Adds example LOs, loans and an October 2026 period for testing.</p>
        </div>
        <Switch checked={includeSampleData} label="Include sample data" onChange={setIncludeSampleData} data-id="element-135" data-mp="2176drgzmm2b3" />
      </div>
    </Modal>;
}